import { render, staticRenderFns } from "./AppNavbarRegister.vue?vue&type=template&id=60799bd6&scoped=true"
import script from "./AppNavbarRegister.vue?vue&type=script&lang=js"
export * from "./AppNavbarRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60799bd6",
  null
  
)

export default component.exports